<template>
  <div class="flex flex-col">
    <p
      v-if="showLabel"
      class="text-neutral-900 font-medium lg:font-bold"
    >
      {{ $t('search.your-location') }}
    </p>
    <div class="mt-4 lg:mt-2">
      <vetster-city-typeahead
        :geo="geo"
        :locale="locale"
        :countries="countries"
        @update="handleLocation"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import VetsterCityTypeahead from '@/brand-components/GuidedSearch/VetsterCityTypeahead';

export default {
  name: 'VetsterLocationSearch',

  components: { VetsterCityTypeahead },

  props: {
    countries: {
      type: String,
      default: 'us',
    },
    defaultInvisibleInput: {
      type: Boolean,
      default: false,
    },
    geo: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: 'en-US',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      inputVisible: false,
    };
  },

  computed: {
    ...mapState('search', ['inputs']),
  },

  watch: {
    'inputs.city': {
      handler(city) {
        if (!city) return;
        this.$emit('location-updated');
        if (!this.defaultInvisibleInput) {
          this.inputVisible = false;
        }
      },
    },
  },

  mounted() {
    if (this.defaultInvisibleInput) {
      this.inputVisible = this.defaultInvisibleInput;
    }
  },

  methods: {
    async handleLocation(data) {
      this.$emit('location-selected', data);
    },
  },
};
</script>
